/**
 * @deprecated use the shared component instead @pflegia/ui/shared/text/title-and-description/TitleAndDescription.component.tsx
 * TODO: remove this and update imports
 */
export { TitleAndDescription } from '@pflegia/ui/shared/text/title-and-description/TitleAndDescription.component';
